// This file is causing memory leaks

const map: Record<string, HTMLElement | undefined | null> = {};

function set(key: string, value: HTMLElement | null) {
  map[key] = value;

  return map;
}

function get(key: string) {
  return map[key];
}

function clear(key: string) {
  map[key] = undefined;

  return map;
}

export { set, clear, get };
